module.exports = __webpack_public_path__ + "static/media/github.97dbd0fc.png";